// src/utils/validationUtils.js
export const getClicktoAnswerGA = (data, task_status, currentTabName, hasMeasurements) => {
    let validationMessageClass = '';

    const isTaskDone = task_status === 2 || task_status === 1;
    const isValidationInRange =
        parseFloat(data.validation) >= parseFloat(data.min) &&
        parseFloat(data.validation) <= parseFloat(data.max);

    if (task_status === 2 && currentTabName === 'Heights') {
        validationMessageClass = ' srv-validation-correct-message';
    } else if (currentTabName === 'Heights' && hasMeasurements[data.short_ques]) {
        validationMessageClass = ' srv-validation-correct-message';
    } else if (!data.isApplicable) {
        if (!!data.validation) {
            if (data.long_heading === 'Diagnostic Visit') {
                if (data.validation === 'Immediate Attention Required by Plant') {
                    if (isTaskDone) {
                        validationMessageClass = !!data.auditor_comments
                            ? ' srv-validation-correct-message'
                            : ' srv-validation-message';
                    } else {
                        validationMessageClass = ' srv-validation-correct-message';
                    }
                } else if (data.validation === '') {
                    validationMessageClass = '';
                } else {
                    validationMessageClass = ' srv-validation-correct-message';
                }
            } else if (data.long_heading !== 'General Audit') {
                if (
                    (task_status !== 2 && !!data.validation) ||
                    (task_status === 2 &&
                        !!data.validation &&
                        ((!!data.observation &&
                            !!data.auditor_comments &&
                            !!data.reviewer_comments) ||
                            isValidationInRange))
                ) {
                    validationMessageClass = ' srv-validation-correct-message';
                } else {
                    validationMessageClass = ' srv-validation-message';
                }
            } else {
                validationMessageClass =
                    !!data.start_date && !!data.end_date && !!data.validation
                        ? ' srv-validation-correct-message'
                        : ' srv-validation-message';
            }
        }
    } else if (!!data.isApplicable) {
        if (
            !!data.observation &&
            (data.long_heading === 'Machine Health' ||
                data.long_heading === 'General Audit' ||
                data.long_heading === 'General Utilities')
        ) {
            validationMessageClass = ' srv-validation-correct-message';
        } else {
            validationMessageClass = ' srv-validation-message';
        }
    }

    return validationMessageClass;
};

export const getClicktoAnswerGFUBP = (data, currentTabName) => {
    if (
        !data.validation &&
        !data.auditor_comments &&
        !data.observation &&
        !data.reviewer_comments &&
        (!data.url || data.url.length === 0)
    ) {
        return !data.isApplicable ? '' : 'srv-validation-message';
    }
    if (!data.isApplicable) {
        if (
            [
                'General Utilities',
                'General Facilities',
                'General Batching',
                'General Processing'
            ].includes(data.long_heading) &&
            (data.validation === 'Pass' ||
                (data.validation !== 'Pass' &&
                    (data.auditor_flag === 2 ||
                        data.auditor_flag === 3 ||
                        (data.url && data.url.length > 0)) &&
                    data.observation &&
                    data.reviewer_comments &&
                    data.auditor_comments))
        ) {
            return 'srv-validation-correct-message';
        } else if (currentTabName === 'PM Quality Assessment') {
            if (data.validation === 'Pass') {
                return 'srv-validation-correct-message';
            } else if (['No', 'Major NC', 'Minor NC'].includes(data.validation)) {
                const hasAllFields =
                    data.auditor_comments &&
                    data.observation &&
                    data.reviewer_comments &&
                    data.url &&
                    data.url.length > 0;

                return hasAllFields ? 'srv-validation-correct-message' : 'srv-validation-message';
            }
        }
    }

    if (data.isApplicable) {
        return data.observation ? 'srv-validation-correct-message' : 'srv-validation-message';
    }

    return 'srv-validation-message';
};

export const getInputClassName = (data, task_status, isSubmitClicked) => {
    let inputClassName = 'form-control';
    if (
        (task_status === 2 || task_status === 1) &&
        !!data.validation &&
        data.validation !== 'Pass' &&
        (!data.url || !data.url.length)
    ) {
        inputClassName += ' upload-blank-field';
    } else if (
        !data.isApplicable &&
        ((data.auditor_flag === 2 &&
            !!data.validation &&
            data.validation !== 'Pass' &&
            !data.url.length) ||
            (!!isSubmitClicked && task_status !== 2 && data.auditor_flag === 1 && !data.url.length))
    ) {
        if (data.long_heading !== 'Diagnostic Visit') {
            inputClassName += ' blank-field';
        }
    }

    return inputClassName;
};

export const getValidationClassName = (data, task_status) => {
    if (data.isApplicable) {
        return data.observation ? 'srv-validation-correct-message' : 'srv-validation-message';
    }

    if (data.validation) {
        if (data.validation === 'Pass') {
            return 'srv-validation-correct-message';
        }

        const missingCommentsOrFiles =
            !data.auditor_comments ||
            !data.reviewer_comments ||
            !data.observation ||
            (task_status === 2 && !data.reviewer_comments) ||
            !data.url ||
            data.url.length === 0;

        return missingCommentsOrFiles ? 'srv-validation-message' : 'srv-validation-correct-message';
    }

    return '';
};

export const getMHValidationClassName = (data, task_status) => {
    if (!data.isApplicable) {
        if (data.validation) {
            if (data.validation === 'Pass') {
                return 'srv-validation-correct-message';
            }

            const missingInfo =
                data.validation !== 'Pass' &&
                (!data.auditor_comments ||
                    !data.observation ||
                    ((task_status === 2 || task_status === 1) && !data.reviewer_comments) ||
                    !data.url ||
                    data.url.length === 0);

            return missingInfo ? 'srv-validation-message' : 'srv-validation-correct-message';
        }
        return '';
    }

    if (data.isApplicable) {
        const condition = !!data.observation;

        return condition ? 'srv-validation-correct-message' : 'srv-validation-message';
    }

    return '';
};

export const getInputObservation = (data, task_status) => {
    let inputObservation = 'form-control';

    if (data.isApplicable === 1 && !data.observation) {
        inputObservation += ' blank-field';
    } else if (
        !data.isApplicable &&
        ((data.auditor_flag === 2 &&
            !!data.validation &&
            data.validation !== 'Pass' &&
            !data.observation) ||
            ((task_status === 2 || task_status === 1) &&
                !!data.validation &&
                data.validation !== 'Pass' &&
                !data.observation))
    ) {
        if (
            data.long_heading !== 'Diagnostic Visit' ||
            data.validation === 'Immediate Attention Required by Plant'
        ) {
            inputObservation += ' blank-field';
        }
    }
    return inputObservation;
};

export const getInputImpact = (data, task_status) => {
    let inputImpact = 'form-control';

    if (
        !data.isApplicable &&
        ((data.auditor_flag === 2 &&
            !!data.validation &&
            data.validation !== 'Pass' &&
            !data.auditor_comments) ||
            ((task_status === 2 || task_status === 1) &&
                !!data.validation &&
                data.validation !== 'Pass' &&
                !data.auditor_comments))
    ) {
        if (
            data.long_heading !== 'Diagnostic Visit' ||
            data.validation === 'Immediate Attention Required by Plant'
        ) {
            inputImpact += ' blank-field';
        }
    }
    return inputImpact;
};

export const getInputRecommendation = (data, task_status) => {
    let inputRecommendation = 'form-control';

    if (
        !data.isApplicable &&
        (task_status === 2 || task_status === 1) &&
        !!data.validation &&
        data.validation !== 'Pass' &&
        !data.reviewer_comments
    ) {
        if (data.long_heading !== 'Diagnostic Visit') {
            inputRecommendation += ' blank-field';
        }
    }
    return inputRecommendation;
};

export const getUploadFileLine = (data) => {
    let uploadFileLine = 'form-control';

    if (
        !data.isApplicable &&
        !!data.validation &&
        data.validation !== 'Pass' &&
        (data.isQuant === 'false' ||
            data.long_ques === 'Standard PM Resources employed during the Assessment') &&
        !data.url.length
    ) {
        if (data.long_heading !== 'Diagnostic Visit') {
            uploadFileLine += ' upload-blank-field';
        }
    }
    return uploadFileLine;
};

export const getInputObservationLine = (data, task_status) => {
    let inputObservationLine = 'form-control';

    const isValidationFailed = !!data.validation && data.validation !== 'Pass';
    const isMachineHealthQuantInvalid =
        task_status === 2 &&
        data.long_heading === 'Machine Health' &&
        data.isQuant === 'true' &&
        !(
            parseFloat(data.validation) >= parseFloat(data.min) &&
            parseFloat(data.validation) <= parseFloat(data.max)
        );

    if (data.isApplicable === 1 && !data.observation) {
        inputObservationLine += ' blank-field';
    } else if (
        (!data.isApplicable &&
            isValidationFailed &&
            data.long_ques !== 'Standard PM Resources employed during the Assessment' &&
            (data.isQuant === 'false' || isMachineHealthQuantInvalid)) ||
        ((!data.observation || data.observation === '') &&
            data.validation !== 'Pass' &&
            data.long_heading === 'PM Quality Assessment')
    ) {
        if (data.long_heading !== 'Diagnostic Visit') {
            if (!data.observation) {
                inputObservationLine += ' blank-field';
            }
        } else if (data.validation === 'Immediate Attention Required by Plant') {
            inputObservationLine += ' blank-field';
        }
    }
    return inputObservationLine;
};

export const getInputImpactLine = (data, task_status) => {
    let inputImpactLine = 'form-control';

    const isValidationFailed = !!data.validation && data.validation !== 'Pass';
    const isMachineHealthQuantInvalid =
        task_status === 2 &&
        data.long_heading === 'Machine Health' &&
        data.isQuant === 'true' &&
        !(
            parseFloat(data.validation) >= parseFloat(data.min) &&
            parseFloat(data.validation) <= parseFloat(data.max)
        );

    if (!data.isApplicable) {
        if (
            (isValidationFailed &&
                (data.isQuant === 'false' || isMachineHealthQuantInvalid) &&
                !data.auditor_comments) ||
            ((!data.auditor_comments || data.auditor_comments === '') &&
                data.validation !== 'Pass' &&
                data.long_heading === 'PM Quality Assessment')
        ) {
            if (data.long_heading !== 'Diagnostic Visit') {
                inputImpactLine += ' blank-field';
            } else if (data.validation === 'Immediate Attention Required by Plant') {
                inputImpactLine += ' blank-field';
            }
        }
    }
    return inputImpactLine;
};

export const getInputRecommendationLine = (data, task_status) => {
    let inputRecommendationLine = 'form-control';

    if (data.long_heading === 'Machine Health' && /mm|%/.test(data.long_ques)) {
        if (!isNaN(Number(data.validation))) {
            return (inputRecommendationLine += '');
        }
    }
    if (data.long_heading === 'General Audit') {
        inputRecommendationLine += '';
    } else if (
        ['1', '2'].includes(String(task_status)) &&
        !!data.validation &&
        data.validation !== 'Pass' &&
        !data.isApplicable &&
        (!data.reviewer_comments || data.reviewer_comments === '')
    ) {
        inputRecommendationLine += ' blank-field';
    }
    return inputRecommendationLine;
};
